import { dashboard_home_route_group } from './home'

export const dashboard_route_group = [...dashboard_home_route_group]
